
<template>
<div class="col-12">
  <button class="btn btn-primary"  @click="showModal()" type="button" >
    <font-awesome-icon icon="fas fa-plus-square" />&nbsp;Markdown Info
  </button>

  <b-modal ref="my-modal" size="xl" hide-footer title="Markdown">
<div class="row">
    <div class="col">
      <b-form-textarea
        id="textarea"
        v-model="text"
        placeholder=""
        rows="230"
        max-rows="230"
      ></b-form-textarea>
    </div>
    <div class="col">
      <vue-markdown :source="text">
        {{this.text}}
      </vue-markdown>
    </div>
</div>

  </b-modal>

</div>
</template>

<script>
import VueMarkdown from "vue-markdown";

export default {
  components: {VueMarkdown},

  data() {
    return {
      text: "# h1 Heading 8-)\n" +
        "<h2> h2 Heading by HTML</h2>\n" +
        "## h2 Heading\n" +
        "### h3 Heading\n" +
        "\n" +
        "## Horizontal Rules\n" +
        "\n" +
        "___\n" +
        "\n" +
        "---\n" +
        "\n" +
        "***\n" +
        "\n" +
        "\n" +
        "## Videos\n" +
        "\n" +
        "<iframe width=\"100%\" height=\"380\" src=\"https://www.youtube.com/embed/V4cC2PKfNhI\" title=\"4K HDR 60fps Dolby Vision with Animal Sounds &amp; Peaceful Music (Colorful Dynamic)\" frameborder=\"0\" allow=\"accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share\" allowfullscreen></iframe>\n" +
        "\n" +
        "## Images\n" +
        "\n" +
        "![Alt text][id]\n" +
        "\n" +
        "With a reference later in the document defining the URL location:\n" +
        "\n" +
        "[id]: https://images.pexels.com/photos/417074/pexels-photo-417074.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500  \"landscape\"\n" +
        "\n" +
        "\n" +
        "\n" +
        "## Typographic replacements\n" +
        "\n" +
        "Enable typographer option to see result.\n" +
        "\n" +
        "(c) (C) (r) (R) (tm) (TM) (p) (P) +-\n" +
        "\n" +
        "test.. test... test..... test?..... test!....\n" +
        "\n" +
        "!!!!!! ???? ,,  -- ---\n" +
        "\n" +
        "\"Smartypants, double quotes\" and 'single quotes'\n" +
        "\n" +
        "\n" +
        "## Emphasis\n" +
        "\n" +
        "**This is bold text**\n" +
        "\n" +
        "__This is bold text__\n" +
        "\n" +
        "*This is italic text*\n" +
        "\n" +
        "_This is italic text_\n" +
        "\n" +
        "~~Strikethrough~~\n" +
        "\n" +
        "\n" +
        "## Blockquotes\n" +
        "\n" +
        "\n" +
        "> Blockquotes can also be nested...\n" +
        ">> ...by using additional greater-than signs right next to each other...\n" +
        "> > > ...or with spaces between arrows.\n" +
        "\n" +
        "\n" +
        "## Lists\n" +
        "\n" +
        "Unordered\n" +
        "\n" +
        "+ Create a list by starting a line with `+`, `-`, or `*`\n" +
        "+ Sub-lists are made by indenting 2 spaces:\n" +
        "  - Marker character change forces new list start:\n" +
        "    * Ac tristique libero volutpat at\n" +
        "    + Facilisis in pretium nisl aliquet\n" +
        "    - Nulla volutpat aliquam velit\n" +
        "+ Very easy!\n" +
        "\n" +
        "Ordered\n" +
        "\n" +
        "1. Lorem ipsum dolor sit amet\n" +
        "2. Consectetur adipiscing elit\n" +
        "3. Integer molestie lorem at massa\n" +
        "\n" +
        "\n" +
        "1. You can use sequential numbers...\n" +
        "1. ...or keep all the numbers as `1.`\n" +
        "\n" +
        "Start numbering with offset:\n" +
        "\n" +
        "57. foo\n" +
        "1. bar\n" +
        "\n" +
        "\n" +
        "## Code\n" +
        "\n" +
        "Inline `code`\n" +
        "\n" +
        "Indented code\n" +
        "\n" +
        "    // Some comments\n" +
        "    line 1 of code\n" +
        "    line 2 of code\n" +
        "    line 3 of code\n" +
        "\n" +
        "\n" +
        "Block code \"fences\"\n" +
        "\n" +
        "```\n" +
        "Sample text here...\n" +
        "```\n" +
        "Syntax highlighting\n" +
        "\n" +
        "``` javascript\n" +
        "var foo = function (bar) {\n" +
        "  return bar++;\n" +
        "};\n" +
        "\n" +
        "console.log(foo(5));\n" +
        "```\n" +
        "\n" +
        "``` go\n" +
        "package main\n" +
        "\n" +
        "import \"fmt\"\n" +
        "\n" +
        "func main() {\n" +
        "\tfmt.Println(\"Hello, world!\")\n" +
        "}\n" +
        "```\n" +
        "\n" +
        "## Tables\n" +
        "\n" +
        "| Option | Description |\n" +
        "| ------ | ----------- |\n" +
        "| data   | path to data files to supply the data that will be passed into templates. |\n" +
        "| engine | engine to be used for processing templates. Handlebars is the default. |\n" +
        "| ext    | extension to be used for dest files. |\n" +
        "\n" +
        "Right aligned columns\n" +
        "\n" +
        "| Option | Description |\n" +
        "| ------:| -----------:|\n" +
        "| data   | path to data files to supply the data that will be passed into templates. |\n" +
        "| engine | engine to be used for processing templates. Handlebars is the default. |\n" +
        "| ext    | extension to be used for dest files. |\n" +
        "\n" +
        "## Links\n" +
        "\n" +
        "[vue-markdown](https://github.com/miaolz123/vue-markdown)\n" +
        "\n" +
        "[link with title](https://github.com/miaolz123/vue-markdown \"VueMarkdown\")\n" +
        "\n" +
        "Autoconverted link https://github.com/miaolz123/vue-markdown (enable linkify to see)\n" +
        "\n" +
        "\n" +
        "### Emojies\n" +
        "\n" +
        "> Classic markup: :wink: :cry: :laughing: :yum:\n" +
        ">\n" +
        "> Shortcuts (emoticons): :-) :-( 8-) ;)\n" +
        "\n" +
        "\n" +
        "### Subscript / Superscript\n" +
        "\n" +
        "- 19^th^\n" +
        "- H~2~O\n" +
        "\n" +
        "\n" +
        "### \\<ins>\n" +
        "\n" +
        "++Inserted text++\n" +
        "\n" +
        "\n" +
        "### \\<mark>\n" +
        "\n" +
        "==Marked text==\n" +
        "\n" +
        "\n" +
        "### Footnotes\n" +
        "\n" +
        "Footnote 1 link[^first].\n" +
        "\n" +
        "Footnote 2 link[^second].\n" +
        "\n" +
        "Inline footnote^[Text of inline footnote] definition.\n" +
        "\n" +
        "Duplicated footnote reference[^second].\n" +
        "\n" +
        "[^first]: Footnote **can have markup**\n" +
        "\n" +
        "    and multiple paragraphs.\n" +
        "\n" +
        "[^second]: Footnote text.\n" +
        "\n" +
        "\n" +
        "### Definition lists\n" +
        "\n" +
        "Term 1\n" +
        "\n" +
        ":   Definition 1\n" +
        "with lazy continuation.\n" +
        "\n" +
        "Term 2 with *inline markup*\n" +
        "\n" +
        ":   Definition 2\n" +
        "\n" +
        "        { some code, part of Definition 2 }\n" +
        "\n" +
        "    Third paragraph of definition 2.\n" +
        "\n" +
        "_Compact style:_\n" +
        "\n" +
        "Term 1\n" +
        "  ~ Definition 1\n" +
        "\n" +
        "Term 2\n" +
        "  ~ Definition 2a\n" +
        "  ~ Definition 2b\n" +
        "\n" +
        "\n" +
        "### Abbreviations\n" +
        "\n" +
        "This is HTML abbreviation example.\n" +
        "\n" +
        "It converts \"HTML\", but keep intact partial entries like \"xxxHTMLyyy\" and so on.\n" +
        "\n" +
        "*[HTML]: Hyper Text Markup Language",

    }
  },
  methods: {

    showModal() {
      this.$refs['my-modal'].show();
    }
  }
}
</script>


<style>
.modal-xl {
  max-width: 80% !important;

}
</style>
